import { useQuery } from "@tanstack/react-query";
import { fetchPromotionalCodes } from "../api/fetchPromotionalCodes";

export const usePromotionalCodes = (filters = {}, enabled = true) => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["promotionalCodes", filters],
    queryFn: () => fetchPromotionalCodes(filters),
    enabled,
  });

  return {
    data: data?.result || null,
    codes: data?.result?.codes || data?.result?.data || [],
    pagination: data?.result?.pagination || null,
    error,
    isLoading,
    refetch,
  };
};

